import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import DropdownIndicator from '../common/DropdownIndicator';
import dropdownStyleUtils from '../../dropdownStyleUtils';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import { isMobile } from '../../screenUtils';
import './ProjectClosure.scss';

const closureReasons = {
  'Project Filled with a Non-Clora resource': [
    'Internally Sourced',
    'Internal Referral',
    'Internal Hire (Current Employee)',
    'Clora Cost Too High',
    'Responsibilities Internally Distributed',
    'Recruiting Agency',
    'CRO',
    'Consulting Agency',
    'Unknown',
  ],
  'Project Unfilled': [
    'Project Scope Change',
    'Loss of Budget',
    'Unable to Meet Client Requirements',
    'Candidate Quality/Culture Fit',
    'Unknown',
  ],
  'Unresponsive Client': null,
  'Unqualified Project': null,
  'Unqualified Company': null,
};

class ProjectClosure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryReason: props.primaryReason,
      secondaryReason: props.secondaryReason,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const { csrfToken, closeProjectUrl, resourceId } = this.props;
    const { primaryReason, secondaryReason } = this.state;

    putRequest(
      closeProjectUrl,
      {
        reason: `${primaryReason}${secondaryReason ? `: ${secondaryReason}` : ''}`,
        project: { resource_id: resourceId },
      },
      csrfToken,
    ).then(() => {
      window.location.reload();
    });
  }

  handleChange(bool) {
    this.setState({ createInvoice: bool });
  }

  render() {
    const { style, triggerText, triggerStyle } = this.props;
    const { primaryReason, secondaryReason } = this.state;

    const menuWidth = isMobile() ? '300px' : '400px';

    return (
      <ModalTrigger
        triggerText={triggerText}
        buttonStyles={`btn btn-sm ${style} ${triggerStyle}`}
        submitButtonText="Mark Project Closed"
        cancelButtonText="Cancel"
        handleSubmit={this.handleSubmit}
        submitDisabled={!primaryReason}
        triggerType="link"
        idKey="close-project-modal"
        modalSize="md"
      >
        <div className="style-guide">
          <h2 className="mb-12">Close Project</h2>
          <div className="body-text-2 mb-3">
            <Select
              classNamePrefix="primary-close-reason"
              options={Object.keys(closureReasons).map((r) => ({ value: r, label: r }))}
              placeholder="Select primary reason"
              value={primaryReason && { value: primaryReason, label: primaryReason }}
              onChange={(opt) => this.setState({ primaryReason: opt.value, secondaryReason: null })}
              styles={{ ...dropdownStyleUtils }}
              width={menuWidth}
              components={{ DropdownIndicator, IndicatorSeparator: () => null }}
            />
          </div>

          { primaryReason && closureReasons[primaryReason]
            && (
            <div className="body-text-2">
              <Select
                classNamePrefix="secondary-close-reason"
                options={closureReasons[primaryReason].map((r) => ({ value: r, label: r }))}
                placeholder="Select secondary reason"
                value={secondaryReason && { value: secondaryReason, label: secondaryReason }}
                onChange={(opt) => this.setState({ secondaryReason: opt.value })}
                styles={{ ...dropdownStyleUtils }}
                width={menuWidth}
                components={{ DropdownIndicator, IndicatorSeparator: () => null }}
              />
            </div>
            )}
        </div>
      </ModalTrigger>
    );
  }
}

ProjectClosure.propTypes = {
  style: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  closeProjectUrl: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  triggerText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  triggerStyle: PropTypes.string,
  primaryReason: PropTypes.string,
  secondaryReason: PropTypes.string,
};

ProjectClosure.defaultProps = {
  primaryReason: null,
  secondaryReason: null,
  triggerText: 'Closed',
  triggerStyle: '',
  style: '',
};

export default ProjectClosure;
